import * as RegisterTypes from 'src/actions/authentication/register/Types';
import * as AuthTypes from 'src/actions/authentication/login/Types';
import * as GetPhysicalPersonTypes from 'src/actions/physical-person/get/Types';
import {
  GetPhysicalPersonAction,
  GetPhysicalPersonSuccess
} from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import { LoginAction } from 'src/actions/authentication/login/Login.actions';
import { RegisterAction } from 'src/actions/authentication/register/Register.actions';

export interface GetPhysicalPersonState {
  physicalPerson?: PhysicalPerson;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetPhysicalPersonState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetPhysicalPersonReducer(
  state: GetPhysicalPersonState = initialState,
  action: GetPhysicalPersonAction | LoginAction | RegisterAction): GetPhysicalPersonState {
  switch (action.type) {
    case RegisterTypes.REGISTER_SUCCESS:
      return {...state, physicalPerson: undefined};
    case AuthTypes.LOGIN_SUCCESS:
      return {...state, physicalPerson: undefined};
    case GetPhysicalPersonTypes.GET_PHYSICAL_PERSON_ATTEMPT:
      return {...state, physicalPerson: undefined, loading: true, error: false};
    case GetPhysicalPersonTypes.GET_PHYSICAL_PERSON_SUCCESS:
      const physicalPerson: PhysicalPerson = (action as GetPhysicalPersonSuccess).payload;
      return {...state, physicalPerson: physicalPerson, loading: false, error: false};
    case GetPhysicalPersonTypes.GET_PHYSICAL_PERSON_FAILURE:
      return {
        ...state,
        physicalPerson: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/physical-person/GetPhysicalPersonReducer.tsx